import React, { Component } from 'react';
import sentGAEvent from '@/ga';
import { Upload, message } from 'antd';
import Utils from '@/utils';
import { withTranslation } from 'react-i18next';
import { getImgWidthHeight } from '@/utils/common';

import AddFileByDragRender from './children/AddFileByDragRender';
import AddFileByDragSmallRender from './children/AddFileByDragSmallRender';
import AddFileByDragThinRender from './children/AddFileByDragThinRender';

import Device from 'current-device';
import Cookies from 'js-cookie';
import sendGaEvent from '@/ga';

const { Dragger } = Upload;

class AddFileByDragFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadClick: false,
    };
    this.stopUpload = false;
  }

  draggerProps = {
    accept: this.props.accept
      ? this.props.accept
      : 'video/*,.mkv,.3gp,.f4v,.rm,.rmvb,.mts,.mxf,.asf,.flv,.vob',
    maxCount: this.props.uploadMaxCount,
    multiple: this.props.uploadMaxCount <= 1 ? false : true,
    onChange: (info) => {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        console.log(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        console.log(`${info.file.name} file upload failed.`);
        this.setState({ uploadFail: true });
      }
    },
    beforeUpload: async (file, fileList) => {
      let uploadFileList = [];
      if (file.uid === fileList[0].uid) {
        this.stopUpload = false;
      }
      if (this.stopUpload) {
        if (file.uid === fileList[fileList.length - 1].uid) {
          this.stopUpload = false;
        }
        return Upload.LIST_IGNORE;
      }

      this.stopUpload = true;
      if (fileList.length > this.props.uploadMaxCount) {
        message.warn(
          this.props.t('Support merging audio files at most', {
            num: this.props.uploadMaxCount,
          })
        );
      }
      for (let index = 0; index < fileList.length; index++) {
        let item = fileList[index];
        // console.log('this.props.work', this.props.work)
        // if (this.props.work === 'dynamicPhoto') {
        //   if (item.size >= 2 * 1024 * 1024) {
        //     this.props.onExceed2M(true)
        //     return Upload.LIST_IGNORE
        //   }
        // } else if (item.size >= 20 * 1024 * 1024) {
        //   this.props.handleWarningObj({
        //     warningInfo: true,
        //     warningInfoText: 'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.',
        //     warningInfoObj: {
        //       type: 'size',
        //       size: (item.size / 1024 / 1024).toFixed(2)
        //     }
        //   })
        //   sentGAEvent({
        //     category: 'Upload',
        //     action: 'ExceedSize',
        //     label:
        //       /\.[^.]+$/.exec(item.name)[0].toLocaleLowerCase() +
        //       '_' +
        //       (item.size / 1024 / 1024).toFixed(2)
        //   })
        //   let category = ''
        //   let action = ''
        //   if (this.props.work === 'audioCut') {
        //     category = 'audio_cut_add_files'
        //     action = 'audio_cut_add_failed'
        //   } else if (this.props.work === 'audioVolume') {
        //     category = 'audio_volume_add_files'
        //     action = 'audio_volume_add_failed'
        //   } else if (this.props.work === 'audioSpeed') {
        //     category = 'audio_speed_add_files'
        //     action = 'audio_speed_add_failed'
        //   }
        //   sentGAEvent({
        //     category,
        //     action
        //   })
        // } else
        console.log(item);
        if (!Utils.validate(item, this.props.accept)) {
          let category = '';
          let action = '';
          if (this.props.work === 'audioCut') {
            category = 'audio_cut_add_files';
            action = 'audio_cut_add_failed';
            sentGAEvent({
              category,
              action,
            });
          } else if (this.props.work === 'audioVolume') {
            category = 'audio_volume_add_files';
            action = 'audio_volume_add_failed';
            sentGAEvent({
              category,
              action,
            });
          } else if (this.props.work === 'audioSpeed') {
            category = 'audio_speed_add_files';
            action = 'audio_speed_add_failed';
            sentGAEvent({
              category,
              action,
            });
          } else if (this.props.work === 'dynamicPhoto') {
            console.log(item);
            console.log('fffffffffffffffffffffffffffffffffff');
          }

          this.props.handleWarningObj({
            warningInfo: true,
            warningInfoText: 'This format is not supported currently.',
            warningInfoObj: {
              type: 'format',
              format: /\.[^.]+$/.exec(item.name)[0].toLocaleLowerCase(),
            },
          });
        } else if (uploadFileList.length < this.props.uploadMaxCount) {
          if (this.props.work === 'dynamicPhoto') {
            if (
              item.size >= 2 * 1024 * 1024 &&
              Utils.isNeedToShowPurchaseModal()
            ) {
              let obj = {
                visible: true,
                text: 'freeAccountExceed',
              };

              this.props.onExceed2M(obj);

              sentGAEvent({
                category: 'Upgrade',
                action: 'OldSizeExceed2M_PrompShow',
                label: 'Null',
              });
              this.props.handlePurchaseModalObjChange({
                trigger: 'SizeExceed2M',
              });
              return Upload.LIST_IGNORE;
            }
          }
          if (this.props.work === 'convert') {
            console.log('进入convert判断');
            if (item.type.indexOf('image') !== -1) {
              let imgSize = await this.isSize(item);
              console.log('imgSize', imgSize);
              if (imgSize > 16000000) {
                this.uploadDialogShow(
                  item,
                  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.'
                );
                // this.props.handleFixedMessageChange({
                //   messageShow:true,
                //   messageText: 'Max file size for Image is 16000000. Get HitPaw Toolkit for big file.'
                // })
                // this.props.handleWarningObj({
                //   warningInfo: true,
                //   warningInfoText: 'Max file size for Image is 16000000. Get HitPaw Toolkit for big file.',
                //   warningInfoObj: {
                //     type: 'size',
                //     size: (item.size / 1024 / 1024).toFixed(2)
                //   }
                // })
                return Upload.LIST_IGNORE;
              }
            } else {
              if (item.size > 500 * 1024 * 1024 && this.props.subscription) {
                this.uploadDialogShow(
                  item,
                  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.'
                );
                // this.props.handleWarningObj({
                //   warningInfo: true,
                //   warningInfoText: 'Max file size for videos is 500 MB. Get HitPaw Toolkit for big file.',
                //   warningInfoObj: {
                //     type: 'size',
                //     size: (item.size / 1024 / 1024).toFixed(2)
                //   }
                // })
                if (
                  Utils.getSystemType() != 'other' &&
                  this.props.work == 'audioExtractor'
                ) {
                  //且当前工作区是音频提取
                  this.props.advertiseConfig({
                    isShowBtn: false, //是否显示not Now 的按钮
                    isShowHeader: false,
                    headerObj: '', //是否显示对话框头部,以及展示类型
                    titleIndex: 0, //标题
                    imgIndex: 0, //图片展示
                    source: 'exceed2G',
                  });
                  this.props.openAdvertiseDialog(true);
                  sentGAEvent({
                    category: 'vc_referral',
                    action: 'AudioExtractor_SizeExceed2GShow',
                  });
                }
                return Upload.LIST_IGNORE;
              } else if (item.size >= 20 * 1024 * 1024) {
                if (Utils.isNeedToShowPurchaseModal()) {
                  // this.props.handlePurchaseModalObjChange({
                  //   visible: true,
                  //   type: 'uploadSizeBiggerThanLimit',
                  //   trigger: 'SizeExceed20M'
                  // })
                  this.uploadDialogShow(
                    item,
                    'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.'
                  );
                  //  this.props.handleWarningObj({
                  //     warningInfo: true,
                  //     warningInfoText: 'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.',
                  //     warningInfoObj: {
                  //       type: 'size',
                  //       size: (item.size / 1024 / 1024).toFixed(2)
                  //     }
                  //   })
                  return Upload.LIST_IGNORE;
                } else {
                  if (
                    Utils.getSystemType() != 'other' &&
                    this.props.work == 'audioExtractor'
                  ) {
                    //且当前工作区是音频提取
                    if (Cookies.get('ignoreAdvertise') == undefined) {
                      //没有忽略广告的Cookie值
                      this.props.advertiseConfig({
                        isShowBtn: true, //是否显示not Now 的按钮
                        isShowHeader: false,
                        headerObj: '', //是否显示对话框头部,以及展示类型
                        titleIndex: 0, //标题
                        imgIndex: 0, //图片展示
                        source: 'exceed20M',
                      });
                      this.props.openAdvertiseDialog(true);
                      sentGAEvent({
                        category: 'vc_referral',
                        action: 'AudioExtractor_SizeExceed20MShow',
                      });
                    }
                  }
                }
              }
            }
          } else {
            if (
              item.size >= 20 * 1024 * 1024 &&
              item.size < 2048 * 1024 * 1024
            ) {
              if (Utils.isNeedToShowPurchaseModal()) {
                this.props.handlePurchaseModalObjChange({
                  visible: true,
                  type: 'uploadSizeBiggerThanLimit',
                  trigger: 'SizeExceed20M',
                });
                let action = Utils.gaUpgradePromptShow(this.props.work);

                if (action) {
                  sendGaEvent({
                    category: 'UpgradePrompShow',
                    action: action,
                    label: 'Null',
                  });
                }
                return Upload.LIST_IGNORE;
              } else {
                if (
                  Utils.getSystemType() !== 'other' &&
                  this.props.work === 'audioExtractor'
                ) {
                  //且当前工作区是音频提取
                  if (Cookies.get('ignoreAdvertise') == undefined) {
                    //没有忽略广告的Cookie值
                    this.props.advertiseConfig({
                      isShowBtn: true, //是否显示not Now 的按钮
                      isShowHeader: false,
                      headerObj: '', //是否显示对话框头部,以及展示类型
                      titleIndex: 0, //标题
                      imgIndex: 0, //图片展示
                      source: 'exceed20M',
                    });
                    this.props.openAdvertiseDialog(true);
                    sentGAEvent({
                      category: 'vc_referral',
                      action: 'AudioExtractor_SizeExceed20MShow',
                    });
                  }
                }
              }
            } else if (item.size > 2048 * 1024 * 1024) {
              if (
                Utils.getSystemType() != 'other' &&
                this.props.work == 'audioExtractor'
              ) {
                //且当前工作区是音频提取
                this.props.advertiseConfig({
                  isShowBtn: false, //是否显示not Now 的按钮
                  isShowHeader: false,
                  headerObj: '', //是否显示对话框头部,以及展示类型
                  titleIndex: 0, //标题
                  imgIndex: 0, //图片展示
                  source: 'exceed2G',
                });
                this.props.openAdvertiseDialog(true);
                sentGAEvent({
                  category: 'vc_referral',
                  action: 'AudioExtractor_SizeExceed2GShow',
                });
              }
              return Upload.LIST_IGNORE;
            }
          }
          this.setState({
            file: item,
          });
          this.props.upload(item);
          uploadFileList.push(item);
        }
      }
      if (uploadFileList.length) {
        this.handleGA(file, uploadFileList);
      }
      return Upload.LIST_IGNORE;
    },
  };

  // componentDidMount() {
  //   this.handleUploadClick = () => {
  //     this.setState({ uploadClick: true });
  //   };
  // }
  handleUploadClick = () => {
    this.setState({ uploadClick: true });
  };

  uploadDialogShow(item, text) {
    if (Device.mobile()) {
      this.props.handleFixedMessageChange({
        messageShow: true,
        messageText: text,
      });
    } else {
      this.props.handleWarningObj({
        warningInfo: true,
        warningInfoText: text,
        warningInfoObj: {
          type: 'size',
          size: (item.size / 1024 / 1024).toFixed(2),
        },
      });
    }
  }

  // 判断尺寸
  isSize(file, width, height) {
    return new Promise((resolve, reject) => {
      let filereader = new FileReader();
      filereader.onload = (e) => {
        let src = e.target.result;
        const image = new Image();
        image.onload = function () {
          // if (
          // (width && this.width != width) ||
          // (height && this.height != height)
          // ) {
          //     console.log("请上传按" + width + "*" + height + "等比缩放的图片");
          //     reject();
          // } else {
          //     resolve();
          // }
          // console.log(console.log("请上传按" + this.width + "*" + this.height + "等比缩放的图片"));
          let pixel = this.width * this.height;
          resolve(pixel);
        };
        image.onerror = reject;
        image.src = src;
      };
      filereader.readAsDataURL(file);
    });
  }
  handleGA = (file, fileList) => {
    switch (this.props.work) {
      case 'addLipShape':
        sentGAEvent({
          category: 'FaceAnimator',
          action: this.state.uploadClick ? 'FaceUpload' : 'FaceDrag',
          label:
            /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
            '_' +
            (file.size / 1024 / 1024).toFixed(2),
        });
        break;
      case 'togif':
        sentGAEvent({
          category: 'ToGif',
          action: this.state.uploadClick ? 'GifUpload' : 'GifDrag',
          label:
            /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
            '_' +
            (file.size / 1024 / 1024).toFixed(2),
        });
        break;
      case 'dynamicPhoto':
        // sentGAEvent({
        //   category: 'AnimateOld',
        //   action: this.state.uploadClick ? 'OldUpload' : 'OldDrag',
        //   label:
        //     /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
        //     '_' +
        //     (file.size / 1024 / 1024).toFixed(2)
        // })
        // console.log('文件：：：：：',file);
        break;
      case 'convert':
        sentGAEvent({
          category: 'Convert',
          action: this.state.uploadClick ? 'ConvertUpload' : 'ConvertDrag',
          label:
            /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
            '_' +
            (file.size / 1024 / 1024).toFixed(2),
        });
        break;
      case 'audioExtractor':
        sentGAEvent({
          category: 'audio_extractor_add_files',
          action: 'audio_extractor_add_files',
          label:
            (this.state.uploadClick ? 'folder' : 'drop') +
            '_' +
            /\.[^.]+$/.exec(file.name)[0].toLocaleLowerCase() +
            '_' +
            (file.size / 1024).toFixed(2) +
            'KB',
        });
        break;
      case 'audioJoiner':
        sentGAEvent({
          category: 'audio_merge_add_files',
          action: 'audio_merge_add_files_format',
          label:
            fileList.length + '_' + (this.state.uploadClick ? 'add' : 'drop'),
        });
        break;
      case 'audioCut':
        sentGAEvent({
          category: 'audio_cut_add_files',
          action: 'audio_cut_add_files',
          label: this.state.uploadClick ? '1_add' : '1_drop',
        });
        break;
      case 'audioVolume':
        sentGAEvent({
          category: 'audio_volume_add_files',
          action: 'audio_volume_add_files',
          label: this.state.uploadClick ? '1_add' : '1_drop',
        });
        break;
      case 'audioSpeed':
        sentGAEvent({
          category: 'audio_speed_add_files',
          action: 'audio_speed_add_files',
          label: this.state.uploadClick ? '1_add' : '1_drop',
        });
        break;
      case 'audioAddMusic':
        sentGAEvent({
          category: 'add_music_add_files',
          action: 'add_music_add_files',
          label:
            fileList.length + '_' + (this.state.uploadClick ? 'add' : 'drop'),
        });
        break;
      case 'videoMute':
        sentGAEvent({
          category: 'mute_add_files',
          action: 'mute_add_files_click',
          label: this.state.uploadClick ? 'choose_file' : 'drag_file',
        });
        break;
      case 'videoCompress':
        sentGAEvent({
          category: 'compress_add_files',
          action: 'compress_add_files_click',
          label: this.state.uploadClick ? 'choose_file' : 'drag_file',
        });
        break;
      case 'imageCutout':
        sentGAEvent({
          category: 'BG_add_files',
          action: 'BG_add_files_click',
          label: this.state.uploadClick ? 'choose_file' : 'drag_file',
        });
        break;
      default:
        break;
    }
    this.setState({
      uploadClick: false,
    });
  };

  render() {
    return (
      <div
        className={`AddFileByDrag ${this.props.size ? this.props.size : ''} ${
          this.props.theme
        }`}
      >
        <Dragger {...this.draggerProps} onClick={this.handleUploadClick}>
          {this.props.size === 'small' ? (
            <AddFileByDragSmallRender
              uploadBtnText={this.props.uploadBtnText}
              uploadNoteText={this.props.uploadNoteText}
            />
          ) : this.props.size === 'thin' ? (
            <AddFileByDragThinRender
              uploadBtnText={this.props.uploadBtnText}
              uploadNoteText={this.props.uploadNoteText}
            />
          ) : (
            <AddFileByDragRender
              theme={this.props.theme}
              uploadBtnText={this.props.uploadBtnText}
              uploadNoteText={this.props.uploadNoteText}
            />
          )}
        </Dragger>
        {/* <Exceed2M /> */}
      </div>
    );
  }
}

export default withTranslation(['common'])(AddFileByDragFunction);
